import { db } from '@/lib/firebase'
import { doc, onSnapshot } from 'firebase/firestore'

const TENANTS_COLLECTION = 'tenants'

export type TenantMaintenance = {
  enabled: boolean
  /** Scheduled end of the maintenance window (drives the countdown), if set. */
  endAt: string | null
  /** When the flag was last toggled — used as the window start. */
  updatedAt: string | null
}

const toIsoOrNull = (input: unknown): string | null => {
  if (!input) return null
  if (typeof input === 'string') return input
  if (typeof (input as { toDate?: () => Date }).toDate === 'function') {
    return (input as { toDate: () => Date }).toDate().toISOString()
  }
  return null
}

/**
 * Real-time subscription to the tenant's maintenance flag, written by
 * FitUP Commander to `tenants/{tenantId}.maintenance` in Firestore.
 */
export const subscribeTenantMaintenance = (
  tenantId: string,
  cb: (maintenance: TenantMaintenance) => void,
  onError?: (err: unknown) => void
): (() => void) => {
  return onSnapshot(
    doc(db, TENANTS_COLLECTION, tenantId),
    (snap) => {
      const maintenance = (snap.data()?.maintenance ?? {}) as Record<string, unknown>
      cb({
        enabled: (maintenance.enabled as boolean) ?? false,
        endAt: toIsoOrNull(maintenance.endAt),
        updatedAt: toIsoOrNull(maintenance.updatedAt),
      })
    },
    onError
  )
}
